import { useGetApi } from '../shared/hooks/fetchingHooks';
import { buildTelemetryUrl } from './api';

export const useTelemetryOperationMetaDataHook = (operationId) => {
    const startingUrl = operationId ? buildTelemetryUrl(operationId) : null;
    const [state, setUrl, forceReload] = useGetApi(startingUrl, {});
    return [state, setUrl, forceReload];
};

export default useTelemetryOperationMetaDataHook;
